function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Oe from "./base-device-parser.js";
import { Browsers as oi, OperatingSystems as so } from "./device-constants.js";

var gi = /*#__PURE__*/function (_Oe) {
  _inherits(gi, _Oe);

  var _super = _createSuper(gi);

  function gi() {
    var _this;

    _classCallCheck(this, gi);

    _this = _super.call(this), _this.fd = gi.Bc(navigator.userAgent || "");
    return _this;
  }

  _createClass(gi, [{
    key: "ef",
    value: function ef() {
      return this.fd[0] || "Unknown Browser";
    }
  }, {
    key: "ff",
    value: function ff() {
      return this.fd[1] || "Unknown Version";
    }
  }, {
    key: "ec",
    value: function ec(r) {
      for (var n = 0; n < r.length; n++) {
        var e = r[n].string;
        var i = gi.nf(e, r[n]);
        if (i) return i === so.Pg && navigator.maxTouchPoints > 1 && (i = so.ao), Promise.resolve(i);
      }

      return Promise.resolve(navigator.platform);
    }
  }], [{
    key: "Bc",
    value: function Bc(r) {
      var n,
          e = r.match(/(samsungbrowser|tizen|roku|konqueror|icab|crios|opera|ucbrowser|chrome|safari|firefox|camino|msie|trident(?=\/))\/?\s*(\.?\d+(\.\d+)*)/i) || [];
      if (-1 !== r.indexOf("(Web0S; Linux/SmartTV)")) return ["LG Smart TV", null];
      if (-1 !== r.indexOf("CrKey")) return ["Chromecast", null];
      if (-1 !== r.indexOf("BRAVIA") || -1 !== r.indexOf("SonyCEBrowser") || -1 !== r.indexOf("SonyDTV")) return ["Sony Smart TV", null];
      if (-1 !== r.indexOf("PhilipsTV")) return ["Philips Smart TV", null];
      if (r.match(/\b(Roku)\b/)) return ["Roku", null];
      if (r.match(/\bAFTM\b/)) return ["Amazon Fire Stick", null];
      if (e[1] === oi.rO && (n = r.match(/\b(OPR|Edge|EdgA|Edg|UCBrowser)\/(\.?\d+(\.\d+)*)/), null != n)) return n = n.slice(1), n[0] = n[0].replace("OPR", oi.oO), n[0] = n[0].replace("EdgA", oi.eO), "Edg" === n[0] && (n[0] = oi.eO), [n[0], n[1]];
      if (e[1] === oi.Bg && (n = r.match(/\b(EdgiOS)\/(\.?\d+(\.\d+)*)/), null != n)) return n = n.slice(1), n[0] = n[0].replace("EdgiOS", oi.eO), [n[0], n[1]];
      if (e = e[2] ? [e[1], e[2]] : [null, null], e[0] === oi.Bg && null != (n = r.match(/version\/(\.?\d+(\.\d+)*)/i)) && e.splice(1, 1, n[1]), null != (n = r.match(/\b(UCBrowser)\/(\.?\d+(\.\d+)*)/)) && e.splice(1, 1, n[2]), e[0] === oi.oO && null != (n = r.match(/mini\/(\.?\d+(\.\d+)*)/i))) return ["Opera Mini", n[1] || ""];

      if (e[0]) {
        var _r = e[0].toLowerCase();

        "crios" === _r && (e[0] = oi.rO), "tizen" === _r && (e[0] = "Samsung Smart TV", e[1] = null), "samsungbrowser" === _r && (e[0] = "Samsung Browser");
      }

      return e;
    }
  }]);

  return gi;
}(Oe);

export { gi as default };